import { render, staticRenderFns } from "./MyAssets.vue?vue&type=template&id=7482b20e&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"
import style0 from "./MyAssets.vue?vue&type=style&index=0&id=7482b20e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7482b20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7482b20e')) {
      api.createRecord('7482b20e', component.options)
    } else {
      api.reload('7482b20e', component.options)
    }
    module.hot.accept("./MyAssets.vue?vue&type=template&id=7482b20e&scoped=true", function () {
      api.rerender('7482b20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Balance/MyAssets.vue"
export default component.exports